import { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

import Modal from '../../shared/Modal';
import text from '../../text.json';
import { removeProject } from '../../redux/api/project';

const RemoveProject = ({ handleClose, isOpen, data }) => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const handleRemoveProject = async () => {
    setIsLoading(true);

    const result = await dispatch(removeProject(data?.id));

    if (result?.error) {
      setIsLoading(false);
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      isDestructive
      isLoading={isLoading}
      handleClose={handleClose}
      isOpen={isOpen}
      primaryButtonText={text.buttons.remove}
      secondaryButtonText={text.buttons.cancel}
      onPrimaryButtonClick={handleRemoveProject}
      onSecondaryButtonClick={handleClose}
      modalTitle={text.remove.title.replace('{{name}}', data?.name)}
    >
      <Typography>
        {text.removeProject.description}
      </Typography>
    </Modal>
  );
};

export default RemoveProject;

RemoveProject.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })
};

RemoveProject.defaultProps = {
  isOpen: false,
  data: {
    id: '',
    name: ''
  }
};
